import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fetches published CMS hero/intro for a page; returns fallback until loaded / if unpublished.
export function usePageCms(pageKey, fallback) {
  const [content, setContent] = useState({ hero: null, intro: "" });
  useEffect(() => {
    let alive = true;
    api.get(`/cms/page/${pageKey}`).then((r) => { if (alive) setContent(r.data || {}); }).catch(() => {});
    return () => { alive = false; };
  }, [pageKey]);
  const hero = { ...(fallback || {}), ...(content.hero || {}) };
  return { hero, intro: content.intro || "", sections: content.sections || [], config: content.config || null };
}
